module.exports = __webpack_public_path__ + "media/glow.eef5017e.webm";